<ds-metadata-link-view [metadata]="metadataValue" [popoverPlacement]="'end'"></ds-metadata-link-view>
